// @flow
import dp4_2l1q1 from './l1q1';
import dp4_2l1q2 from './l1q2';
import dp4_2l1q3 from './l1q3';
import dp4_2l1q4 from './l1q4';
import dp4_2l1q5 from './l1q5';
import dp4_2l3q1 from './l3q1';
import dp4_2l3q2 from './l3q2';
import dp4_2l3q3 from './l3q3';
import dp4_2l3q4 from './l3q4';
import dp4_2l3q5 from './l3q5';
import dp4_2l3q6 from './l3q6';
import dp4_2l5q1 from './l5q1';
import dp4_2l5q2 from './l5q2';
import dp4_2l5q3 from './l5q3';
import dp4_2l5q4 from './l5q4';
import dp4_2l5q5 from './l5q5';
import dp4_2l7q1 from './l7q1';
import dp4_2l7q2 from './l7q2';
import dp4_2l7q3 from './l7q3';
import dp4_2l7q4 from './l7q4';
import dp4_2l7q5 from './l7q5';

const questions = {
    dp4_2l1q1,
    dp4_2l1q2,
    dp4_2l1q3,
    dp4_2l1q4,
    dp4_2l1q5,
    dp4_2l3q1,
    dp4_2l3q2,
    dp4_2l3q3,
    dp4_2l3q4,
    dp4_2l3q5,
    dp4_2l3q6,
    dp4_2l5q1,
    dp4_2l5q2,
    dp4_2l5q3,
    dp4_2l5q4,
    dp4_2l5q5,
    dp4_2l7q1,
    dp4_2l7q2,
    dp4_2l7q3,
    dp4_2l7q4,
    dp4_2l7q5
}
export default questions;



// WEBPACK FOOTER //
// ./src/constants/dp/questions/cat4.2/index.js